import * as CSS from 'csstype'
import { foundations, TokenFoundationSpace } from '@vori/gourmet-tokens'

export function tokenOrValue(
  value: CSS.Property.Gap<TokenFoundationSpace>,
): CSS.Property.Gap {
  return foundations.space[value as TokenFoundationSpace] || value
}
